import { Component, Input } from '@angular/core';

@Component({
    moduleId: module.id,
    selector: 'panel',
    templateUrl: 'panel.component.html',
})
export class PanelComponent {
    @Input()
    public hasBody: boolean = false;
    @Input()visible = false;
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/panel/panel.component.ts